import React from "react";

const APP_STORE_URL = "https://apps.apple.com/us/app/aris-your-guide-to-balance/id6744324334";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.aris.ai";

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M16.365 1.43c0 1.14-.42 2.23-1.18 3.04-.78.83-2.05 1.46-3.1 1.38-.13-1.1.42-2.25 1.16-3.06.84-.92 2.27-1.6 3.12-1.36zm3.92 17.07c-.69 1.6-1.02 2.31-1.91 3.72-1.24 1.97-2.99 4.42-5.16 4.44-1.93.02-2.43-1.26-5.05-1.25-2.62.02-3.17 1.27-5.1 1.25C1.9 26.64.27 24.43-.97 22.46-4.45 16.96-4.81 10.49-2.62 7.04c1.55-2.45 4-3.88 6.31-3.88 2.35 0 3.83 1.29 5.78 1.29 1.89 0 3.05-1.29 5.77-1.29 2.07 0 4.27 1.13 5.83 3.08-5.13 2.81-4.29 10.16.92 12.26z" transform="translate(2,-1)" />
  </svg>
);

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M3.6 1.4c-.4.4-.6 1-.6 1.7v17.8c0 .7.2 1.3.6 1.7l.1.1L13.6 12 3.7 1.3l-.1.1zM17.4 15.7l-3.3-3.3 3.3-3.3 4.1 2.3c1.2.7 1.2 1.8 0 2.5l-4.1 1.8zm-2.2-2.2L4.7 24c.5.4 1.2.5 2 .1l11-6.3-2.5-4.3zm0-3l2.5-4.3-11-6.3c-.8-.4-1.5-.3-2 .1l10.5 10.5z" />
  </svg>
);

const DomainAssessmentView = ({ item }) => {
  return (
    <div className="ye-upsell">
      {item?.icon && (
        <div className="ye-upsell-icon">
          <img src={item.icon} alt="" />
        </div>
      )}
      <h2 className="ye-upsell-title">Continue on the Aris app</h2>
      <p className="ye-upsell-body">
        {item?.title
          ? `Finish "${item.title}" in the Aris mobile app to unlock it on web.`
          : "Finish this domain in the Aris mobile app to unlock it on web."}
      </p>
      <div className="ye-store-row">
        <a
          className="ye-store-btn"
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppleIcon />
          <span className="ye-store-btn-label">
            <span className="ye-store-btn-label-small">Download on the</span>
            <span className="ye-store-btn-label-large">App Store</span>
          </span>
        </a>
        <a
          className="ye-store-btn"
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <GoogleIcon />
          <span className="ye-store-btn-label">
            <span className="ye-store-btn-label-small">Get it on</span>
            <span className="ye-store-btn-label-large">Google Play</span>
          </span>
        </a>
      </div>
    </div>
  );
};

export default DomainAssessmentView;
